import { RefreshIcon } from '@repo/atomic-components';
import { OutlineIconButton } from '@/ui/components/OutlineIconButton';

type MedicalMatchRerunButtonProps = {
  /** Whether the backend currently allows a full rerun (`can-rerun`). */
  canRerun: boolean;
  /** Hover text — either the prompt to re-run or the reason it's unavailable. */
  tooltip: string;
  /** True from the POST until the invalidated `can-rerun` refetch settles. */
  isRerunning: boolean;
  onRerun: () => void;
};

export function MedicalMatchRerunButton({ canRerun, tooltip, isRerunning, onRerun }: MedicalMatchRerunButtonProps) {
  return (
    // Icon-only by design: the header has room for a 32px button, not a label.
    // Hover sits on the wrapper rather than the button so the tooltip still
    // opens while the button is disabled — which is exactly when the reason
    // matters. Same CSS-only group-hover tooltip as InfoTooltipIcon, opening
    // downwards because the button lives at the top of the panel.
    <div className="group relative shrink-0">
      <OutlineIconButton
        icon={<RefreshIcon />}
        loading={isRerunning}
        disabled={!canRerun || isRerunning}
        onClick={onRerun}
        aria-label="Re-run Medical Match"
        className="!bg-white"
      />
      <div className="pointer-events-none invisible absolute top-full right-0 z-[999999] mt-1 w-[220px] rounded-xl border border-gray-100 bg-white px-4 py-3 text-sm whitespace-pre-line text-black opacity-0 shadow-xl transition-opacity duration-100 group-hover:visible group-hover:opacity-100">
        {tooltip}
      </div>
    </div>
  );
}
